import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CapitalizeFirstLetterPipe } from '../../pipes'
import { IconComponent } from '../icon'
import { Illustration, IllustrationComponent } from '../illustration'
import { TertiaryButtonComponent } from '../tertiary-button'

export const ErrorStateSizes = ['tiny', 'small', 'medium', 'large'] as const
export type ErrorStateSize = (typeof ErrorStateSizes)[number]

@Component({
  selector: 'ftr-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.css'],
  imports: [IconComponent, IllustrationComponent, CapitalizeFirstLetterPipe, TertiaryButtonComponent],
})
/**
 * A component to display an error with a retry link
 */
export class ErrorStateComponent {
  @Input() entityName: string = ''
  //@deprecated: use size
  @Input() small: boolean = false

  @Input()
  set size(value: ErrorStateSize) {
    this._size = value
  }
  get size(): ErrorStateSize {
    return this._size ?? (this.small ? 'small' : 'large')
  }
  private _size?: ErrorStateSize
  @Input() transparent = false
  @Input() errorMessage?: string
  @Output() onRetry = new EventEmitter()

  protected readonly illustration = Illustration
}
